import axios from 'axios'
import Vue from 'vue'
const instanct = axios.create({
    baseURL: 'https://culture.aqitai.com/',
    timeout: 90000,
    headers: {
        'Content-Type': 'application/json'
    }
})

instanct.interceptors.request.use((req) => {
    req.headers.Authorization = 'Bearer ' + ((localStorage.token) ? (localStorage.token) : '')
    if (req.method == 'get') {
        if (req.params) {
            req.params.apiterminal = 'Aqt_20230517ApiWeb'
        } else {
            let keyVal = {
                apiterminal: 'Aqt_20230517ApiWeb'
            }
            Vue.prototype.$set(req, 'params', keyVal)
        }

    } else if (req.method == 'post') {
        console.log('req', req)
        if (req.data) {
            req.data.apiterminal = 'Aqt_20230517ApiWeb'
        } else {
            let keyVal = {
                apiterminal: 'Aqt_20230517ApiWeb'
            }
            Vue.prototype.$set(req, 'data', keyVal)
        }
    }
    return req
})

instanct.interceptors.response.use((res) => {

    if(localStorage.getItem('userInfos')){
        let userDatas = JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfos')))
        let last_login_time = userDatas.last_login_time
        if(last_login_time){
            var gcmTime = new Date(last_login_time).getTime()
            var nowTime = Date.now();
            //1*60*60*1000
            if(nowTime - gcmTime> 6*60*60*1000){
                //超出6小时了
                handleErr({code:403})
            }
        }else{
            handleErr({code:403})
        }
    }

    let mainData = Object.assign({}, res.data)
    if (res.config.method == 'get') {
        let resdata = Object.assign({}, mainData.data)
        if (resdata.current_page) {
            delete resdata.data
        }
        if (mainData.code === 200) {
            return {
                data: resdata.current_page ? mainData.data.data : mainData.data,
                info: {
                    'code': mainData.code,
                    'message': mainData.message
                },
                pages: resdata.current_page ? resdata : 0
            }
        } else {
            handleErr(mainData)
            return Promise.reject({
                'code': mainData.code,
                'message': mainData.message
            })
        }
    } else {
        if (mainData.code === 200) {
            return mainData
        } else {
            handleErr(mainData)
            return Promise.reject({
                'code': mainData.code,
                'message': mainData.message
            })
        }
    }
}, err => {
    if (err.response.status === 401) {
        localStorage.clear()
        sessionStorage.clear()
        Vm.$store.state.layout.tabList = '[]'
        Vm.$router.push(`/login_zh?number=${localStorage.getItem('gcm')}`)
    } else {
        if (!err.response) {
            handleErr({
                code: '请求无响应！',
                message: err.config.url
            })
            return false
        }
    }
    return Promise.reject(err)
})

function handleErr(data) {
    if (data.code == 403) {
        Vm.$Notice.error({
            title: '登录超时',
            desc: '请重新登录'
        })
        setTimeout(() => {
            localStorage.removeItem("userInfoMemberId");
            localStorage.removeItem("userInfos");
            Vm.$store.commit("SET_UserInfor", '');
            Vm.$router.push(`/index?number=${localStorage.getItem('gcm')}`)
        }, 1000)
        return false
    } else {
        //201 本单位未开通此权限
        // 202 当前馆藏未分配资源权限
        // 203 该用户不在当前单位！
        // 204 用户已禁用
        // 205 用户已注销
        //
        if(data.code == 201){
            Vm.$Message.warning({
                render: h => {
                    return h('span',
                        '本单位未开通此权限')
                },
            });
        }else if(data.code == 202){
            Vm.$Message.warning({
                render: h => {
                    return h('span',
                        '当前馆藏未分配资源权限')
                },
            });
        }else if(data.code == 203){
            Vm.$Message.warning({
                render: h => {
                    return h('span',
                        '该用户不在当前单位')
                },
            });
        }else if(data.code == 204){
            Vm.$Message.warning({
                render: h => {
                    return h('span',
                        '用户已禁用')
                },
            });
        }else if(data.code == 205){
            Vm.$Message.warning({
                render: h => {
                    return h('span',
                        '用户已注销')
                },
            });
        }else {
            if(data.code){
                Vm.$Notice.error({
                    title: data.code,
                    desc: data.message
                })
            }

        }
    }
}

export default instanct
